export default import.meta.ROLLDOWN_FILE_URL_TRTQWy19KwNZaJkwa1gJLQ